function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.56283 8.90107L0.754855 11.7059C0.550743 11.9098 0.550559 12.2395 0.754442 12.4436C0.856124 12.5454 0.989659 12.5966 1.12322 12.5967C1.25679 12.5968 1.39038 12.5457 1.49217 12.444L4.30015 9.63921L3.56283 8.90107Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.453 4.4082L8.80294 0.754026C8.59906 0.549914 8.26932 0.54973 8.06521 0.753614C7.8611 0.957497 7.86091 1.28723 8.0648 1.49134L8.53826 1.96534L2.78645 5.17131L2.01836 4.40237C1.81448 4.19826 1.48474 4.19807 1.28063 4.40196C1.07652 4.60584 1.07634 4.93558 1.28022 5.13969L8.05897 11.926C8.16065 12.0278 8.29418 12.079 8.42775 12.0791C8.56131 12.0792 8.6949 12.0281 8.7967 11.9264C9.00081 11.7225 9.00099 11.3928 8.79711 11.1887L8.02903 10.4198L11.2414 4.67152L11.7149 5.14552C11.8166 5.24731 11.9501 5.29852 12.0837 5.29859C12.2172 5.29867 12.3508 5.24761 12.4526 5.14593C12.6567 4.94205 12.6569 4.61231 12.453 4.4082Z",
  fill: "currentColor"
});

function SvgPinnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnIcon);
export default __webpack_public_path__ + "static/media/pinn-icon.d08f4068.svg";
export { ForwardRef as ReactComponent };